import React from 'react';
import '../styles/MarqueeStrip.css';

interface MarqueeStripProps {
  names: string[];
  tail?: string;
}

interface RunProps {
  names: string[];
  tail?: string;
}

const Run: React.FC<RunProps> = ({ names, tail }) => (
  <span>
    {names.map((n) => (
      <React.Fragment key={n}>
        <span>{n}</span>
        <span className="strip__dot" aria-hidden="true" />
      </React.Fragment>
    ))}
    {tail && (
      <>
        <em>{tail}</em>
        <span className="strip__dot" aria-hidden="true" />
      </>
    )}
  </span>
);

const MarqueeStrip: React.FC<MarqueeStripProps> = ({ names, tail }) => (
  <div className="strip" aria-hidden="true">
    <div className="strip__track">
      <Run names={names} tail={tail} />
      <Run names={names} tail={tail} />
    </div>
  </div>
);

export default MarqueeStrip;
